module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "top-bar"
  }, [_vm._m(0), _vm._v(" "), ([2, 3, 4, 5].includes(_vm.user.role)) ? _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.session_account_current),
      expression: "session_account_current"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.session_account_current = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeAccount($event)
      }]
    }
  }, _vm._l((_vm.user.accounts), function(account) {
    return _c('option', {
      key: ("account-" + (account.id)),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n          " + _vm._s(account.name) + " - "), _c('b', [_vm._v(_vm._s(account.prefix))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (
    [2, 3, 4, 5].includes(_vm.user.role) &&
    !['calendar', 'emails', 'campaigns'].includes(_vm.$route.name)
  ) ? _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.session_team_current),
      expression: "session_team_current"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.session_team_current = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeTeam($event)
      }]
    }
  }, _vm._l((_vm.filteredTeams), function(team) {
    return _c('option', {
      key: ("team-" + (team.id)),
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n          " + _vm._s(team.name) + "\n        ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-2"
  }, [_c('a', {
    staticClass: "dropdown-toggle notification cursor-pointer flex gap-1",
    attrs: {
      "href": "/activities",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "flex mt-1 gap-1 border-theme-1 zoom-in py-1 px-2 text-theme-1 rounded-full border border-white z-50"
  }, [_c('app-icon', {
    attrs: {
      "name": "activities",
      "classname": "notification__icon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Actividades")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-2"
  }, [_c('a', {
    staticClass: "dropdown-toggle notification cursor-pointer flex gap-1",
    attrs: {
      "href": "/rrhh",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "flex mt-1 gap-1 border-theme-1 text-theme-1 zoom-in py-1 px-2 rounded-full border z-50"
  }, [_c('app-icon', {
    attrs: {
      "name": "newspaper",
      "classname": "notification__icon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Solicitudes")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:ml-4 sm:mr-2 hidden-xs"
  }, [_c('div', {
    staticClass: "dropdown-toggle notification cursor-pointer",
    class: {
      'notification--bullet': _vm.filteredNotificationsNotViews.length,
    },
    on: {
      "mouseover": function($event) {
        _vm.btn_noti = true
      },
      "mouseleave": function($event) {
        _vm.btn_noti = false
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'bell',
      "classname": 'notification__icon text-theme-1'
    }
  }), _vm._v(" "), (_vm.btn_noti) ? _c('div', {
    staticClass: "fixed bg-theme-1 py-1 px-2 text-white rounded border border-white z-50 -mt-12 -ml-24 mr-2"
  }, [_vm._v("\n          Notificaciones\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "notification-content dropdown-box mt-8 absolute top-0 left-0 sm:left-auto sm:right-0 z-20 -ml-10 sm:ml-0"
  }, [_c('div', {
    staticClass: "notification-content__box dropdown-box__content box"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "notification-content__title mb-0"
  }, [_vm._v("Notificaciones")]), _vm._v(" "), (_vm.filteredNotificationsNotViews.length > 0) ? _c('div', {
    staticClass: "hover:text-blue-600 hover:underline cursor-pointer text-xs",
    on: {
      "click": function($event) {
        return _vm.readAllNotifications()
      }
    }
  }, [_vm._v("\n              Marcar todas como leidas\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-notifications"
  }, _vm._l((_vm.filteredNotifications), function(notification) {
    return _c('div', {
      key: ("notification-" + (notification.id)),
      staticClass: "border-t-2 flex items-center pt-1 relative"
    }, [_c('div', {
      staticClass: "ml-2 overflow-hidden w-full mb-2"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "text-xs text-gray-500 ml-auto whitespace-no-wrap courser-not"
    }, [_vm._v("\n                    " + _vm._s(notification.created_at) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "w-full cursor-pointer",
      class: {
        'text-gray-600': notification.view == 1,
        'text-blue-600': notification.view == 0,
      },
      on: {
        "click": function($event) {
          return _vm.updateNotification(notification)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(notification.name) + "\n                ")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:ml-2 sm:mr-4 hidden-xs cursor-pointer",
    on: {
      "click": _vm.changeTheme
    }
  }, [_c('app-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDark),
      expression: "isDark"
    }],
    attrs: {
      "name": "sun",
      "classname": "notification__icon text-theme-1"
    }
  }), _vm._v(" "), _c('app-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDark),
      expression: "!isDark"
    }],
    attrs: {
      "name": "moon",
      "classname": "notification__icon text-theme-1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown w-8 h-8 relative"
  }, [_c('div', {
    staticClass: "dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
  }, [(_vm.user.avatar) ? _c('img', {
    attrs: {
      "alt": "Profile",
      "src": _vm.user.avatar
    }
  }) : _c('img', {
    attrs: {
      "alt": "Profile",
      "src": "/static/FAVICON-2026.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-box mt-10 absolute w-56 top-0 right-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box bg-theme-38 text-white"
  }, [_c('div', {
    staticClass: "p-4 border-b border-theme-40"
  }, [_c('div', {
    staticClass: "font-medium flex"
  }, [_vm._v("\n              " + _vm._s(_vm.user.name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), (_vm.user.team) ? _c('div', {
    staticClass: "text-xs"
  }, [_vm._v("\n              " + _vm._s(_vm.user.team.name) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/profile"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "user",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Perfil\n            ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/accounts-auth"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "folder",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Cuentas\n            ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/notes"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "edit",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Mis Notas\n            ")], 1)], 1), _vm._v(" "), (_vm.session_team_current == 1 || _vm.user.role == 1) ? _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/developments"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "code",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Desarrollos\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-2 border-t border-theme-40"
  }, [_c('a', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    on: {
      "click": _vm.doLogout
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "toggle-right",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Salir\n            ")], 1)])])])]), _vm._v(" "), _c('app-alerts', {
    attrs: {
      "category": "Anuncios"
    }
  })], 1), _vm._v(" "), (_vm.birthday) ? _c('div', [_c('div', {
    staticClass: "birthday rounded py-2 px-4 shadow-lg bg-white flex justify-between"
  }, [_c('div', {
    staticClass: "text-lg text-theme-10 font-bold bg-white"
  }, [_vm._v("\n        ¡Feliz cumpleaños " + _vm._s(_vm.user.name) + " !\n      ")]), _vm._v(" "), (_vm.user.prize) ? _c('a', {
    staticClass: "bg-theme-10 rounded text-white font-bold p-1 text-center",
    attrs: {
      "href": _vm.user.prize,
      "target": "_blank"
    }
  }, [_vm._v("REDIMIR BONO")]) : _vm._e()])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "-intro-x breadcrumb mr-auto hidden-xs"
  }, [_c('a', {
    staticClass: "hidden-xs",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("MyInxait")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296c8212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/partials/Top.vue
// module id = 425
// module chunks = 1